import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

import { TLSAPVersion } from '@/api/gen/tessera-backend-api.schemas';
import { CodeEditorProvider } from '@/features/code-editor/CodeEditorProvider';
import { Editor } from '@/features/editor/Editor';
import { EditorStoreProvider } from '@/features/editor/providers/EditorStoreProvider';
import { PageLayout } from '@/features/page-layout/PageLayout';
import { TLAIDomain } from '@/types/api';

export const Route = createFileRoute('/_protected/t/$tenantId/editor/$')({
  component: RouteComponent,
  validateSearch: z
    .object({
      programId: z.string().optional(),
      sapVersion: z.nativeEnum(TLSAPVersion).optional(),
      sourcePath: z.string().optional(),
      remedyObjectId: z.string().optional(),
    })
    .refine((d) => (d.sapVersion === undefined) === (d.sourcePath === undefined), {
      message: 'sapVersion and sourcePath must both be present or both absent',
    }),
});

function RouteComponent() {
  const { _splat } = Route.useParams();
  const { programId, sapVersion, sourcePath, remedyObjectId } = Route.useSearch();

  const [domain, correlationId] = _splat?.split('/') ?? [];

  const activeDomain = domain?.toUpperCase()
    ? (TLAIDomain[domain.toUpperCase() as keyof typeof TLAIDomain] ?? TLAIDomain.EDITOR)
    : TLAIDomain.EDITOR;

  return (
    <PageLayout header>
      <EditorStoreProvider initialState={{ domain: activeDomain, correlationId }}>
        <CodeEditorProvider>
          <Editor
            domain={activeDomain}
            correlationId={correlationId}
            programId={programId}
            sapVersion={sapVersion}
            sourcePath={sourcePath}
            remedyObjectId={remedyObjectId}
          />
        </CodeEditorProvider>
      </EditorStoreProvider>
    </PageLayout>
  );
}
